import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Combobox } from "@/components/ui/combobox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { SettlementOrAdvanceApiFilterValues } from "./types";
import { DEFAULT_SETTLEMENT_OR_ADVANCE_FILTER_VALUES } from "./types";

interface SettlementOrAdvanceFilterModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  draftFilters: SettlementOrAdvanceApiFilterValues;
  setDraftFilters: React.Dispatch<React.SetStateAction<SettlementOrAdvanceApiFilterValues>>;
  onApply: () => void;
  commodityOptions: { value: string; label: string }[];
  type: "settlements" | "advances";
}

export function SettlementOrAdvanceFilterModal({
  open,
  onOpenChange,
  draftFilters,
  setDraftFilters,
  onApply,
  commodityOptions,
  type,
}: SettlementOrAdvanceFilterModalProps) {
  const handleClear = () => {
    setDraftFilters({ ...DEFAULT_SETTLEMENT_OR_ADVANCE_FILTER_VALUES });
  };

  const isSettlements = type === "settlements";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] md:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Filters</DialogTitle>
        </DialogHeader>

        <form onSubmit={(e) => { e.preventDefault(); onApply(); }}>
          <div className="space-y-4 py-2">
            {isSettlements ? (
              <div className="flex flex-col gap-1">
                <Label htmlFor="filter-serial-settlement-nbrs" className="text-xs">
                  Settlement Number
                </Label>
                <Input
                  id="filter-serial-settlement-nbrs"
                  placeholder=""
                  value={draftFilters.serialSettlementNbrs}
                  onChange={(e) =>
                    setDraftFilters((prev) => ({ ...prev, serialSettlementNbrs: e.target.value }))
                  }
                />
              </div>
            ) : (
              <div className="flex flex-col gap-1">
                <Label htmlFor="filter-serial-advance-nbrs" className="text-xs">
                  Advance Number
                </Label>
                <Input
                  id="filter-serial-advance-nbrs"
                  placeholder=""
                  value={draftFilters.serialAdvanceNbrs}
                  onChange={(e) =>
                    setDraftFilters((prev) => ({ ...prev, serialAdvanceNbrs: e.target.value }))
                  }
                />
              </div>
            )}

            <div className="flex flex-col gap-1">
              <Label className="text-xs">Commodity</Label>
              <Combobox
                options={commodityOptions}
                value={draftFilters.commodityId}
                onValueChange={(val) =>
                  setDraftFilters((prev) => ({ ...prev, commodityId: val }))
                }
                placeholder="Select commodity..."
                isModal
                dwimOnChange
              />
            </div>

          </div>

          <div className="flex justify-between pt-2">
            <Button type="button" variant="outline" onClick={handleClear}>
              Clear All
            </Button>
            <div className="flex gap-2">
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button type="submit">
                Apply Filters
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
